// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface Grade
 */
export interface Grade {
    /**
     * 
     * @type {string}
     * @memberof Grade
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof Grade
     */
    name: string;
}

export function GradeFromJSON(json: any): Grade {
    return {
        'slug': json['slug'],
        'name': json['name'],
    };
}

export function GradeToJSON(value?: Grade): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'slug': value.slug,
        'name': value.name,
    };
}


